import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import authService from '../../api-authorization/AuthorizeService';
import { ApplicationPaths } from '../../api-authorization/ApiAuthorizationConstants';

export function LoginMenu () {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userName, setUserName] = useState(null);

    const populateState = async () => {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
        setIsAuthenticated(isAuthenticated);
        setUserName(user?.name);
    };

    useEffect(() => {
        const subscription = authService.subscribe(populateState);
        populateState();
        return () => authService.unsubscribe(subscription);
    }, []);

    return (
        <>
            {isAuthenticated ? (
                <>
                    <li>
                        <Link to={ApplicationPaths.Profile}>
                            Hello {userName}
                        </Link>
                    </li>
                    <li>
                        <Link to={{ pathname: `${ApplicationPaths.LogOut}`, state: { local: true } }}>
                            Logout
                        </Link>
                    </li>
                </>
            ) : (
                <>
                    <li>
                        <Link to={ApplicationPaths.Register}>
                            Register
                        </Link>
                    </li>
                    <li>
                        <Link to={ApplicationPaths.Login}>
                            Login
                        </Link>
                    </li>
                </>
            )}
        </>
    );
}